const LogoutLoadingScreen = () => {
    return (
        <div dir="rtl" className="fixed inset-0 z-[9999] flex min-h-screen items-center justify-center overflow-hidden bg-[#251658] px-4 text-white">
            <div className="absolute inset-0 bg-[#251658]" />
            <div className="relative flex w-full max-w-sm flex-col items-center rounded-2xl border border-white/15 bg-white/10 px-8 py-9 text-center shadow-2xl shadow-black/25 backdrop-blur-xl">
                <img className="mb-7 w-32" src="/logo-white-ar.webp" alt="Absat ERP" />
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full border border-white/20 bg-white/10">
                    <div className="h-8 w-8 animate-spin rounded-full border-4 border-white/25 border-t-white" />
                </div>
                <h1 className="text-xl font-bold">جاري تسجيل الخروج</h1>
                <p className="mt-2 text-sm leading-6 text-white/75">يتم الآن تأمين الجلسة وتحويلك لصفحة الدخول.</p>
            </div>
        </div>
    );
};

export default LogoutLoadingScreen;
